module.exports = __webpack_public_path__ + "static/img/2.99b9108.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chongqing/2.jpg
// module id = QqGb
// module chunks = 1